import { ILocation, RegionOption } from "lib/types";
import iso3166 from "iso-3166-2";
/**
 * Gets ISO 3166-2 subdivisions for a given country code.
 * @param countryCode - ISO 3166-1 alpha-2 code (e.g. 'NG', 'US')
 */
export function getRegionsByCountryCode(countryCode: string): RegionOption[] {
  if (!countryCode) [];
  const entry = iso3166.country(countryCode);
  if (!entry || !entry.sub) return [];

  return Object.entries(entry.sub).map(([code, region]) => ({
    value: code,
    label: region.name,
  }));
}

// Utility function to parse JSON string and return an ILocation object
export function parseLocation(json: string): ILocation | null {
  try {
    const obj = JSON.parse(json);
    if (typeof obj !== "object" || obj === null) return null;
    return obj as ILocation;
  } catch (e) {
    console.error("Failed to parse location JSON:", e);
    return null;
  }
}

// Utility function to validate minimum fields needed to render a location on a map and serialize
export function serializeLocation(location: ILocation): string | null {
  const hasLatLon = typeof location.latitude === "number" && typeof location.longitude === "number";
  const hasAddress = location.streetName && location.city && location.country;

  if (!hasLatLon && !hasAddress) {
    return null; // not enough data to map reliably
  }

  return JSON.stringify(location);
}

export const parseLegacyLocationString = (location: string) => {
  const parts = location.split(",").map(part => part.trim());

  // Initialize with empty strings
  let address = "";
  let city = "";
  let state = "";
  let country = "";

  // Handle different cases based on number of parts
  switch (parts.length) {
    case 3: // Format: address, state, country
      [address, state, country] = parts;
      break;
    case 4: // Format: address, city, state, country
      [address, city, state, country] = parts;
      break;
    default:
      // Fallback - just use the full string as address
      address = location;
      break;
  }

  return { address, city, state, country };
};
